import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { ButtonProps } from '@mui/material';

interface AccountIconButtonProps {
  onClick: () => void;
  ButtonWrapper: React.ComponentType<ButtonProps>;
  enableQRCode?: boolean;
}

const AccountIconButton: React.FC<AccountIconButtonProps> = ({
  onClick,
  ButtonWrapper,
  enableQRCode,
}) => (
  <ButtonWrapper
    type="button"
    onClick={onClick}
    aria-label={enableQRCode ? 'quick check-in qr code' : 'account'}
    data-testid="account-button"
  >
    {enableQRCode ? <QrCode2Icon /> : <PersonIcon />}
  </ButtonWrapper>
);

export default AccountIconButton;
